import type { VariantInfo, Campaign, ICampaignVariantVersion } from '~/modules/campaign/types';
import type { ICGTemplateVariantProperty } from '../types';

import { CGTemplatePairPropertyAction } from './CGTemplatePairPropertyAction';
import { CGTemplatePairPropertyLabel } from './CGTemplatePairPropertyLabel';
import { useCampaignAnalyticContext } from '~/modules/campaign-analytics';
import { MetricProperty } from '~/modules/campaign/modules';
import { IVariantType } from '~/modules/campaign/types';
import { useMemo } from 'react';

interface CGTemplatePairPropertyProps {
  property: ICGTemplateVariantProperty;
  variant: VariantInfo;
  campaign: Campaign;
  campaignVariants?: Record<string, ICampaignVariantVersion>;
}

export const CGTemplatePairProperty: React.FC<CGTemplatePairPropertyProps> = (props) => {
  const { metrics, isEmptyMetricData } = useCampaignAnalyticContext();
  const { property, variant, campaign, campaignVariants } = props;

  const variantType = variant.isOrigin ? IVariantType.VARIANT_A : IVariantType.VARIANT_B;
  const metric = useMemo(() => {
    if (isEmptyMetricData) return;

    return metrics?.find((m) => m?.variantKey === variantType);
  }, [metrics, variantType, isEmptyMetricData]);

  switch (property) {
    case 'GTable-Cell--label':
      return (
        <CGTemplatePairPropertyLabel
          variant={variant}
          campaign={campaign}
          campaignVariants={campaignVariants}
        />
      );
    case 'conversionRate':
      return <MetricProperty metric={metric} functionKey="getConversionRateMetric" />;
    case 'revenueRate':
      return <MetricProperty metric={metric} functionKey="getTotalRevenueMetric" />;
    case 'totalOrders':
      return <MetricProperty metric={metric} functionKey="getTotalOrderMetric" />;
    case 'totalSessions':
      return <MetricProperty metric={metric} functionKey="getTotalSessionMetric" />;
    case 'action':
      return <CGTemplatePairPropertyAction variant={variant} campaign={campaign} />;
    default:
      return null;
  }
};
